export enum BaseType {
    Ceiling = "ceiling",
    Chimney = "chimney",
    RoofDrainage = "roof_drainage",
    GroundDrainage = "ground_drainage",
    Facade = "facade",
    Floor = "floor",
    Foundation = "foundation",
    GeoTechnics = "geo_technics",
    InteriorWall = "interior_wall",
    Outdoor = "outdoor",
    Roof = "roof",
    Structural = "structural",
    Wall = "wall",
    Utility = "utility",
    Window = "window",
    Door = "door",
    SheetMetal = "sheet_metal",
}

export enum BuildComponentType {
    FacadeVerticalSiding = "facade_vertical_siding",
    FacadeHorizontalSiding = "facade_horizontal_siding",
    FacadeCavityWall = "facade_cavity_wall",
    FacadeRender = "facade_render",
    FacadeThinRender = "facade_thin_render",
    FacadePlinth = "facade_plinth",
    FacadeSandwichPanel = "facade_sandwich_panel",
    FacadeCorrugatedMetal = "facade_corrugated_metal",

    Geotechnics = "geotechnics",

    FoundationGroundSlab = "foundation_ground_slab",
    FoundationCrawlSpace = "foundation_crawl_space",
    FoundationSlopingSite = "foundation_sloping_site",
    FoundationCellar = "foundation_cellar",
    FoundationPile = "foundation_pile",
    FoundationPier = "foundation_pier",
    FoundationWallOnFooting = "foundation_wall_on_footing",
    FoundationBlindingLayer = "foundation_blinding_layer",
    FoundationRaisedFloor = "foundation_raised_floor",

    ChimneyStack = "chimney_stack",
    ChimneyFlue = "chimney_flue",
    ChimneyCap = "chimney_cap",

    RoofCorrugatedMetal = "roof_corrugated_metal",
    RoofFiberCement = "roof_fiber_cement",
    RoofRolledSheetMetal = "roof_rolled_sheet_metal",
    RoofSedum = "roof_sedum",
    RoofBrick = "roof_brick",
    RoofConcrete = "roof_concrete",
    RoofGlass = "roof_glass",
    RoofPlastic = "roof_plastic",
    RoofTar = "roof_tar",

    DrainageDrainpipe = "drainage_drainpipe",
    DrainageGutter = "drainage_gutter",

    GroundDrainagePipe = "ground_drainage_pipe",
    GroundDrainageStoneFilled = "ground_drainage_stone_filled_drain",
    GroundDrainageManhole = "ground_drainage_manhole",
    GroundDrainageCleanout = "ground_drainage_cleanout",
    GroundDrainageMat = "ground_drainage_mat",

    StructuralStudWallInterior = "structural_stud_wall_interior",
    StructuralStudWallExterior = "structural_stud_wall_exterior",
    StructuralSandwichInterior = "structural_sandwich_interior",
    StructuralSandwichExterior = "structural_sandwich_exterior",
    StructuralSolidWallInterior = "structural_solid_wall_interior",
    StructuralSolidWallExterior = "structural_solid_wall_exterior",
    StructuralPanelsInterior = "structural_panels_interior",
    StructuralPanelsExterior = "structural_panels_exterior",
    StructuralConcreteWall = "structural_concrete_wall",
    StructuralBrickWall = "structural_brick_wall",
    StructuralMasonryWall = "structural_masonry_wall",
    StructuralLightweightConcreteWall = "structural_lightweight_concrete_wall",

    StructuralColumnInFacade = "structural_column_in_facade",
    StructuralColumnInteriorWall = "structural_column_interior_wall",
    StructuralButtress = "structural_buttress",
    StructuralExposedBeam = "structural_exposed_beam",
    StructuralConcealedBeam = "structural_concealed_beam",

    StructuralFloorWoodBeam = "structural_floor_wood_beam",
    StructuralFloorSteelBeam = "structural_floor_steel_beam",
    StructuralFloorConcreteBeam = "structural_floor_concrete_beam",
    StructuralFloorSolidSlab = "structural_floor_solid_slab",

    StructuralRoofBeam = "structural_roof_beam",
    StructuralRoofTruss = "structural_roof_truss",
    StructuralRoofLightweightConcreteElement = "structural_roof_lightweight_concrete_element",
    StructuralRoofCassettes = "structural_roof_cassettes",
    StructuralRoofMetalSheetTrp = "structural_roof_metal_sheet_trp",
    StructuralRoofConcrete = "structural_roof_concrete",

    OutdoorTerrace = "outdoor_terrace",
    OutdoorPavedArea = "outdoor_paved_area",
    OutdoorPavement = "outdoor_pavement",
    OutdoorWoodenFence = "outdoor_wooden_fence",
    OutdoorWoodenPlank = "outdoor_wooden_plank",
    OutdoorStoneWall = "outdoor_stone_wall",
    OutdoorGrassArea = "outdoor_grass_area",
    OutdoorParkingGravel = "outdoor_parking_gravel",
    OutdoorParkingAsphalt = "outdoor_parking_asphalt",
    OutdoorPavedAreaStone = "outdoor_paved_area_stone",
    OutdoorPavedAreaAsphalt = "outdoor_paved_area_asphalt",
    OutdoorPermanentFurniture = "outdoor_permanent_furniture",
    OutdoorPlayground = "outdoor_playground",
    OutdoorSwingSet = "outdoor_swing_set",
    OutdoorSandbox = "outdoor_sandbox",
    OutdoorSlide = "outdoor_slide",
    OutdoorOther = "outdoor_other",

    InteriorWall = "interior_wall",
    InteriorCeiling = "interior_ceiling",
    InteriorFloor = "interior_floor",
    
    // Door types
    DoorWood = "door_wood",
    DoorAluminium = "door_aluminium",
    DoorPvc = "door_pvc",
    DoorGlass = "door_glass",
    
    // Window types
    WindowWood = "window_wood",
    WindowAluminium = "window_aluminium", 
    WindowPvc = "window_pvc",
    WindowGlass = "window_glass",

    // Sheet metal types - distinguished by coating
    SheetMetalPainted = "sheet_metal_painted",
    SheetMetalAluZinc = "sheet_metal_alu_zinc",
    SheetMetalCopper = "sheet_metal_copper",
    SheetMetalGalvanized = "sheet_metal_galvanized",
    SheetMetalUntreatedSteel = "sheet_metal_untreated_steel",
    SheetMetalStainlessSteel = "sheet_metal_stainless_steel",

    UtilityGeothermalHeatPumpEarth = "utility_geothermal_heat_pump_earth",
    UtilityGeothermalHeatPumpBedrock = "utility_geothermal_heat_pump_bedrock",
    UtilityElectricBoiler = "utility_electric_boiler",
    UtilityPelletBoiler = "utility_pellet_boiler",
    UtilityWoodBoiler = "utility_wood_boiler",
    UtilityAirToAirHeatPump = "utility_air_to_air_heat_pump",
    UtilityAirToWaterHeatPump = "utility_air_to_water_heat_pump",
    UtilityAirConditioning = "utility_air_conditioning",
    UtilityDistrictCooling = "utility_district_cooling",
    UtilityPoolHeating = "utility_pool_heating",

    UtilitySVentilation = "utility_s_ventilation",
    UtilityFVentilation = "utility_f_ventilation",
    UtilityFtVentilation = "utility_ft_ventilation",
    UtilityFxVentilation = "utility_fx_ventilation",
    UtilityFtxVentilation = "utility_ftx_ventilation",

    UtilityPassengerElevator = "utility_passenger_elevator",
    UtilityFreightElevator = "utility_freight_elevator",

    UtilitySmokeDetector = "utility_smoke_detector",
    UtilityFireAlarm = "utility_fire_alarm",
    UtilityFireBlanket = "utility_fire_blanket",
    UtilityFireExtinguisher = "utility_fire_extinguisher",
    UtilitySprinkler = "utility_sprinkler",
    UtilityFireControlPanel = "utility_fire_control_panel",

    UtilityMechanicalDehumidification = "utility_mechanical_dehumidification",
    UtilityRadonExtractor = "utility_radon_extractor",
    UtilityVentilatedFloorUnit = "utility_ventilated_floor_unit",
    UtilitySorptionDehumidification = "utility_sorption_dehumidification",
    UtilitySafetyGuardSystem = "utility_safety_guard_system",

    UtilityElectricMainSwitchboard = "utility_electric_main_switchboard",
    UtilityElectricSubSwitchboard = "utility_electric_sub_switchboard",

    UtilityToiletWater = "utility_toilet_water",
    UtilityToiletClosed = "utility_toilet_closed",
    UtilityToiletSolar = "utility_toilet_solar",
    UtilityToiletCompost = "utility_toilet_compost",
    UtilityToiletWasteBarrels = "utility_toilet_waste_barrels",
    UtilityBathroomSink = "utility_bathroom_sink",
    UtilityShower = "utility_shower",
    UtilityPorcelainToilet = "utility_porcelain_toilet",
    UtilityBathtub = "utility_bathtub",
    UtilityKitchenSink = "utility_kitchen_sink",
    UtilityRefrigerator = "utility_refrigerator",
    UtilityFreezer = "utility_freezer",
    UtilityCombinedRefrigeratorFreezer = "utility_combined_refrigerator_freezer",
    UtilityOven = "utility_oven",
    UtilityStove = "utility_stove",
    UtilityDishwasher = "utility_dishwasher",
    UtilityMicrowave = "utility_microwave",
    UtilityKitchenExhaustfan = "utility_kitchen_exhaustfan",
    UtilityWashingMachine = "utility_washing_machine",
    UtilityDryer = "utility_dryer",
    UtilityDryingCabinet = "utility_drying_cabinet",
    UtilityMangle = "utility_mangle",
    
    UtilityDrilledWell = "utility_drilled_well",
    UtilityWellPump = "utility_well_pump",

    DoorDefault = "door_default",
    WindowDefault = "window_default",
}

export const COMPONENT_TO_BASE_TYPE: Record<BuildComponentType, BaseType> = {
    // Facade components
    [BuildComponentType.FacadeVerticalSiding]: BaseType.Facade,
    [BuildComponentType.FacadeHorizontalSiding]: BaseType.Facade,
    [BuildComponentType.FacadeCavityWall]: BaseType.Facade,
    [BuildComponentType.FacadeRender]: BaseType.Facade,
    [BuildComponentType.FacadeThinRender]: BaseType.Facade,
    [BuildComponentType.FacadePlinth]: BaseType.Facade,
    [BuildComponentType.FacadeSandwichPanel]: BaseType.Facade,
    [BuildComponentType.FacadeCorrugatedMetal]: BaseType.Facade,

    // Geotechnics
    [BuildComponentType.Geotechnics]: BaseType.GeoTechnics,

    // Foundation components
    [BuildComponentType.FoundationGroundSlab]: BaseType.Foundation,
    [BuildComponentType.FoundationCrawlSpace]: BaseType.Foundation,
    [BuildComponentType.FoundationSlopingSite]: BaseType.Foundation,
    [BuildComponentType.FoundationCellar]: BaseType.Foundation,
    [BuildComponentType.FoundationPile]: BaseType.Foundation,
    [BuildComponentType.FoundationPier]: BaseType.Foundation,
    [BuildComponentType.FoundationWallOnFooting]: BaseType.Foundation,
    [BuildComponentType.FoundationBlindingLayer]: BaseType.Foundation,
    [BuildComponentType.FoundationRaisedFloor]: BaseType.Foundation,

    // Chimney components
    [BuildComponentType.ChimneyStack]: BaseType.Chimney,
    [BuildComponentType.ChimneyFlue]: BaseType.Chimney,
    [BuildComponentType.ChimneyCap]: BaseType.Chimney,

    // Roof components
    [BuildComponentType.RoofCorrugatedMetal]: BaseType.Roof,
    [BuildComponentType.RoofFiberCement]: BaseType.Roof,
    [BuildComponentType.RoofRolledSheetMetal]: BaseType.Roof,
    [BuildComponentType.RoofSedum]: BaseType.Roof,
    [BuildComponentType.RoofBrick]: BaseType.Roof,
    [BuildComponentType.RoofConcrete]: BaseType.Roof,
    [BuildComponentType.RoofGlass]: BaseType.Roof,
    [BuildComponentType.RoofPlastic]: BaseType.Roof,
    [BuildComponentType.RoofTar]: BaseType.Roof,

    // Drainage components
    [BuildComponentType.DrainageDrainpipe]: BaseType.RoofDrainage,
    [BuildComponentType.DrainageGutter]: BaseType.RoofDrainage,

    // Ground drainage components
    [BuildComponentType.GroundDrainagePipe]: BaseType.GroundDrainage,
    [BuildComponentType.GroundDrainageStoneFilled]: BaseType.GroundDrainage,
    [BuildComponentType.GroundDrainageManhole]: BaseType.GroundDrainage,
    [BuildComponentType.GroundDrainageCleanout]: BaseType.GroundDrainage,
    [BuildComponentType.GroundDrainageMat]: BaseType.GroundDrainage,

    // Structural wall components
    [BuildComponentType.StructuralStudWallInterior]: BaseType.Structural,
    [BuildComponentType.StructuralStudWallExterior]: BaseType.Structural,
    [BuildComponentType.StructuralSandwichInterior]: BaseType.Structural,
    [BuildComponentType.StructuralSandwichExterior]: BaseType.Structural,
    [BuildComponentType.StructuralSolidWallInterior]: BaseType.Structural,
    [BuildComponentType.StructuralSolidWallExterior]: BaseType.Structural,
    [BuildComponentType.StructuralPanelsInterior]: BaseType.Structural,
    [BuildComponentType.StructuralPanelsExterior]: BaseType.Structural,
    [BuildComponentType.StructuralConcreteWall]: BaseType.Structural,
    [BuildComponentType.StructuralBrickWall]: BaseType.Structural,
    [BuildComponentType.StructuralMasonryWall]: BaseType.Structural,
    [BuildComponentType.StructuralLightweightConcreteWall]: BaseType.Structural,

    // Structural column/beam components
    [BuildComponentType.StructuralColumnInFacade]: BaseType.Structural,
    [BuildComponentType.StructuralColumnInteriorWall]: BaseType.Structural,
    [BuildComponentType.StructuralButtress]: BaseType.Structural,
    [BuildComponentType.StructuralExposedBeam]: BaseType.Structural,
    [BuildComponentType.StructuralConcealedBeam]: BaseType.Structural,

    // Structural floor components
    [BuildComponentType.StructuralFloorWoodBeam]: BaseType.Structural,
    [BuildComponentType.StructuralFloorSteelBeam]: BaseType.Structural,
    [BuildComponentType.StructuralFloorConcreteBeam]: BaseType.Structural,
    [BuildComponentType.StructuralFloorSolidSlab]: BaseType.Structural,

    // Structural roof components
    [BuildComponentType.StructuralRoofBeam]: BaseType.Structural,
    [BuildComponentType.StructuralRoofTruss]: BaseType.Structural,
    [BuildComponentType.StructuralRoofLightweightConcreteElement]: BaseType.Structural,
    [BuildComponentType.StructuralRoofCassettes]: BaseType.Structural,
    [BuildComponentType.StructuralRoofMetalSheetTrp]: BaseType.Structural,
    [BuildComponentType.StructuralRoofConcrete]: BaseType.Structural,

    // Outdoor components
    [BuildComponentType.OutdoorTerrace]: BaseType.Outdoor,
    [BuildComponentType.OutdoorPavedArea]: BaseType.Outdoor,
    [BuildComponentType.OutdoorPavement]: BaseType.Outdoor,
    [BuildComponentType.OutdoorWoodenFence]: BaseType.Outdoor,
    [BuildComponentType.OutdoorWoodenPlank]: BaseType.Outdoor,
    [BuildComponentType.OutdoorStoneWall]: BaseType.Outdoor,
    [BuildComponentType.OutdoorGrassArea]: BaseType.Outdoor,
    [BuildComponentType.OutdoorParkingGravel]: BaseType.Outdoor,
    [BuildComponentType.OutdoorParkingAsphalt]: BaseType.Outdoor,
    [BuildComponentType.OutdoorPavedAreaStone]: BaseType.Outdoor,
    [BuildComponentType.OutdoorPavedAreaAsphalt]: BaseType.Outdoor,
    [BuildComponentType.OutdoorPermanentFurniture]: BaseType.Outdoor,
    [BuildComponentType.OutdoorPlayground]: BaseType.Outdoor,
    [BuildComponentType.OutdoorSwingSet]: BaseType.Outdoor,
    [BuildComponentType.OutdoorSandbox]: BaseType.Outdoor,
    [BuildComponentType.OutdoorSlide]: BaseType.Outdoor,
    [BuildComponentType.OutdoorOther]: BaseType.Outdoor,

    // Interior components
    [BuildComponentType.InteriorWall]: BaseType.InteriorWall,
    [BuildComponentType.InteriorCeiling]: BaseType.Ceiling,
    [BuildComponentType.InteriorFloor]: BaseType.Floor,
    
    // Door components
    [BuildComponentType.DoorWood]: BaseType.Door,
    [BuildComponentType.DoorAluminium]: BaseType.Door,
    [BuildComponentType.DoorPvc]: BaseType.Door,
    [BuildComponentType.DoorGlass]: BaseType.Door,
    
    // Window components
    [BuildComponentType.WindowWood]: BaseType.Window,
    [BuildComponentType.WindowAluminium]: BaseType.Window,
    [BuildComponentType.WindowPvc]: BaseType.Window,
    [BuildComponentType.WindowGlass]: BaseType.Window,

    // Sheet metal components
    [BuildComponentType.SheetMetalPainted]: BaseType.SheetMetal,
    [BuildComponentType.SheetMetalAluZinc]: BaseType.SheetMetal,
    [BuildComponentType.SheetMetalCopper]: BaseType.SheetMetal,
    [BuildComponentType.SheetMetalGalvanized]: BaseType.SheetMetal,
    [BuildComponentType.SheetMetalUntreatedSteel]: BaseType.SheetMetal,
    [BuildComponentType.SheetMetalStainlessSteel]: BaseType.SheetMetal,

    // Utility components - all map to BaseType.Utility
    [BuildComponentType.UtilityGeothermalHeatPumpEarth]: BaseType.Utility,
    [BuildComponentType.UtilityGeothermalHeatPumpBedrock]: BaseType.Utility,
    [BuildComponentType.UtilityElectricBoiler]: BaseType.Utility,
    [BuildComponentType.UtilityPelletBoiler]: BaseType.Utility,
    [BuildComponentType.UtilityWoodBoiler]: BaseType.Utility,
    [BuildComponentType.UtilityAirToAirHeatPump]: BaseType.Utility,
    [BuildComponentType.UtilityAirToWaterHeatPump]: BaseType.Utility,
    [BuildComponentType.UtilityAirConditioning]: BaseType.Utility,
    [BuildComponentType.UtilityDistrictCooling]: BaseType.Utility,
    [BuildComponentType.UtilityPoolHeating]: BaseType.Utility,
    [BuildComponentType.UtilitySVentilation]: BaseType.Utility,
    [BuildComponentType.UtilityFVentilation]: BaseType.Utility,
    [BuildComponentType.UtilityFtVentilation]: BaseType.Utility,
    [BuildComponentType.UtilityFxVentilation]: BaseType.Utility,
    [BuildComponentType.UtilityFtxVentilation]: BaseType.Utility,
    [BuildComponentType.UtilityPassengerElevator]: BaseType.Utility,
    [BuildComponentType.UtilityFreightElevator]: BaseType.Utility,
    [BuildComponentType.UtilitySmokeDetector]: BaseType.Utility,
    [BuildComponentType.UtilityFireAlarm]: BaseType.Utility,
    [BuildComponentType.UtilityFireBlanket]: BaseType.Utility,
    [BuildComponentType.UtilityFireExtinguisher]: BaseType.Utility,
    [BuildComponentType.UtilitySprinkler]: BaseType.Utility,
    [BuildComponentType.UtilityFireControlPanel]: BaseType.Utility,
    [BuildComponentType.UtilityMechanicalDehumidification]: BaseType.Utility,
    [BuildComponentType.UtilityRadonExtractor]: BaseType.Utility,
    [BuildComponentType.UtilityVentilatedFloorUnit]: BaseType.Utility,
    [BuildComponentType.UtilitySorptionDehumidification]: BaseType.Utility,
    [BuildComponentType.UtilitySafetyGuardSystem]: BaseType.Utility,
    [BuildComponentType.UtilityElectricMainSwitchboard]: BaseType.Utility,
    [BuildComponentType.UtilityElectricSubSwitchboard]: BaseType.Utility,
    [BuildComponentType.UtilityToiletWater]: BaseType.Utility,
    [BuildComponentType.UtilityToiletClosed]: BaseType.Utility,
    [BuildComponentType.UtilityToiletSolar]: BaseType.Utility,
    [BuildComponentType.UtilityToiletCompost]: BaseType.Utility,
    [BuildComponentType.UtilityToiletWasteBarrels]: BaseType.Utility,
    [BuildComponentType.UtilityBathroomSink]: BaseType.Utility,
    [BuildComponentType.UtilityShower]: BaseType.Utility,
    [BuildComponentType.UtilityPorcelainToilet]: BaseType.Utility,
    [BuildComponentType.UtilityBathtub]: BaseType.Utility,
    [BuildComponentType.UtilityKitchenSink]: BaseType.Utility,
    [BuildComponentType.UtilityRefrigerator]: BaseType.Utility,
    [BuildComponentType.UtilityFreezer]: BaseType.Utility,
    [BuildComponentType.UtilityCombinedRefrigeratorFreezer]: BaseType.Utility,
    [BuildComponentType.UtilityOven]: BaseType.Utility,
    [BuildComponentType.UtilityStove]: BaseType.Utility,
    [BuildComponentType.UtilityDishwasher]: BaseType.Utility,
    [BuildComponentType.UtilityMicrowave]: BaseType.Utility,
    [BuildComponentType.UtilityKitchenExhaustfan]: BaseType.Utility,
    [BuildComponentType.UtilityWashingMachine]: BaseType.Utility,
    [BuildComponentType.UtilityDryer]: BaseType.Utility,
    [BuildComponentType.UtilityDryingCabinet]: BaseType.Utility,
    [BuildComponentType.UtilityMangle]: BaseType.Utility,
    [BuildComponentType.UtilityDrilledWell]: BaseType.Utility,
    [BuildComponentType.UtilityWellPump]: BaseType.Utility,

    [BuildComponentType.DoorDefault]: BaseType.Utility,
    [BuildComponentType.WindowDefault]: BaseType.Utility,
} as const;

export enum MaintenanceIntervalType {
    years = "years",
    months = "months", 
    weeks = "weeks",
    days = "days"
}

type _ValidateMapping = {
    [K in BuildComponentType]: K extends keyof typeof COMPONENT_TO_BASE_TYPE ? true : never;
};

// Helper functions
export function getBaseType(componentType: BuildComponentType): BaseType {
    return COMPONENT_TO_BASE_TYPE[componentType];
}

export function getComponentsByBaseType(baseType: BaseType): BuildComponentType[] {
    return Object.entries(COMPONENT_TO_BASE_TYPE)
        .filter(([, base]) => base === baseType)
        .map(([component]) => component as BuildComponentType);
}

export enum Material {
    Wood = "wood",
    Brick = "brick",
    SheetMetal = "sheet_metal",
    Render = "render",
    RenderThick = "render_thick",
    RenderThin = "render_thin",
    Concrete = "concrete",
    LightweightConcrete = "lightweight_concrete",
    Granite = "granite",
    Aluminum = "aluminum",
    Pvc = "pvc",
    CementBoard = "cement_board",
    MetalWorksOnFacade = "metal_works_on_facade",
    Leca = "leca",
    Steel = "steel",
    CorrugatedMetal = "corrugated_metal",
    FiberCement = "fiber_cement",
    RolledSheetMetal = "rolled_sheet_metal",
    RoofingFelt = "roofing_felt",
    Sedum = "sedum",
    SoilLayer = "soil_layer",
    ConcreteCastInPlace = "concrete_cast_in_place",
    ConcretePrecast = "concrete_precast",
    WoodGlulam = "wood_glulam",
    WoodPrefab = "wood_prefab",
    StructuralTimber = "structural_timber",
    AsbestosCement = "asbestos_cement",
    OrganicMaterial = "organic_material",
    SteelDecking = "steel_decking",
    Stone = "stone",
    Composite = "composite",
    Gravel = "gravel",
    Metal = "metal",
    Grass = "grass",
    Plastic = "plastic",

    ConcretePainted = "concrete_painted",
    Drywall = "drywall",
    DrywallPainted = "drywall_painted",
    DrywallWallpaper = "drywall_wallpaper",
    WoodPanelPainted = "wood_panel_painted",
    WoodPanelBare = "wood_panel_bare",
    RenderPainted = "render_painted",
    CeramicTiles = "ceramic_tiles",
    FloorTiles = "floor_tiles",
    FloorCarpet = "floor_carpet",
    FloorLaminate = "floor_laminate",
    FloorVinyl = "floor_vinyl",
    FloorParquet = "floor_parquet",
    AcousticTiles = "acoustic_tiles",
    DropTiles = "drop_tiles",
    Plywood = "plywood",
    CastIron = "cast_iron",
}

export enum RiskConstructionType {
    RiskCrawlSpace = "risk_crawl_space",
    RiskSingleStageSealedRender = "risk_single_stage_sealed_render",
    RiskFloatingFloor = "risk_floating_floor",
    RiskUninsulatedSlabOnGround = "risk_uninsulated_slab_on_ground",
    RiskExternallyVentilatedAttic = "risk_externally_ventilated_attic",
    RiskCompactRoofNoAirGap = "risk_compact_roof_no_air_gap",
    RiskInternalDrainage = "risk_internal_drainage",
    RiskLowSlopeRoof = "risk_low_slope_roof",
    RiskBuiltInWaterConnections = "risk_built_in_water_connections",
    RiskExternalWallNoVaporBarrier = "risk_external_wall_no_vapor_barrier",
    RiskUngroundedElectricalSystem = "risk_ungrounded_electrical_system",
    RiskCablesThroughExternalWallRoof = "risk_cables_through_external_wall_roof"
}

export enum UtilityCategory {
    Ventilation = "ventilation",
    HeatingCooling = "heating_cooling",
    Elevator = "elevator",
    FireSafety = "fire_safety",
    MechanicalMaintenanceRiskConstructions = "mechanical_maintenance_risk_constructions",
    Electrical = "electrical",
    WaterAndSewage = "water_and_sewage",
    DoorAutomation = "door_automation"
}

export enum ElevatorType {
    TractionElevator = "traction_elevator",
    Stairlift = "stairlift",
    HydraulicElevator = "hydraulic_elevator"
}

export enum CardinalDirection {
    North = "north",
    NorthEast = "north_east",
    East = "east",
    SouthEast = "south_east",
    South = "south",
    SouthWest = "south_west",
    West = "west",
    NorthWest = "north_west"
}

export enum ColorEnum {
    ColorWhite = "color_white",
    ColorBlack = "color_black",
    ColorLightGrey = "color_lightGrey",
    ColorDarkGrey = "color_darkGrey",
    ColorBeige = "color_beige",
    ColorYellow = "color_yellow",
    ColorLightBlue = "color_lightBlue",
    ColorDarkBlue = "color_darkBlue",
    ColorLightGreen = "color_lightGreen",
    ColorDarkGreen = "color_darkGreen",
    ColorRed = "color_red",
    ColorFaluRed = "color_faluRed",
    ColorBrown = "color_brown",
    ColorTerracotta = "color_terracotta",
    ColorPink = "color_pink",
    ColorPurple = "color_purple",
    ColorOrange = "color_orange",
    ColorTurquoise = "color_turquoise"
}

export enum HazardType {
    HazardAsbestos = "hazard_asbestos",
    HazardLed = "hazard_led",
    HazardPcb = "hazard_pcb",
    HazardArsenic = "hazard_arsenic",
    HazardBlueConcrete = "hazard_blue_concrete",
    HazardRadon = "hazard_radon"
}

export enum RoofShape {
    RoofShapeGable = "roof_shape_gable",
    RoofShapeMansard = "roof_shape_mansard",
    RoofShapeHip = "roof_shape_hip",
    RoofShapeShed = "roof_shape_shed",
    RoofShapeInvertedShed = "roof_shape_inverted_shed",
    RoofShapeCylindrical = "roof_shape_cylindrical",
    RoofShapeLowSlope = "roof_shape_low_slope",
    RoofShapeFlat = "roof_shape_flat"
}

export enum RoomType {
    RoomGeneral = "room_general",
    RoomKitchen = "room_kitchen",
    RoomAssembly = "room_assembly",
    RoomOffice = "room_office",
    RoomBathroom = "room_bathroom",
    RoomStorage = "room_storage",
    RoomUtility = "room_utility",
    RoomEntryway = "room_entryway",
    RoomHallway = "room_hallway",
    RoomChanging = "room_changing",
    RoomWork = "room_work",
    RoomConference = "room_conference",
    RoomLecture = "room_lecture",
    RoomExhibit = "room_exhibit",
    RoomWarmAttic = "room_warm_attic",
    RoomColdAttic = "room_cold_attic",
    RoomLaundry = "room_laundry",
    RoomStairwell = "room_stairwell",
    
    // Residential/Living Spaces
    RoomBedroom = "room_bedroom",
    RoomLivingRoom = "room_living_room",
    RoomDiningRoom = "room_dining_room",
    RoomServer = "room_server",
    RoomCleaning = "room_cleaning",
    RoomTrash = "room_trash",
    RoomBikeStorage = "room_bike_storage",
    RoomReception = "room_reception",
    RoomCafeteria = "room_cafeteria",
    RoomGym = "room_gym",
    RoomArchive = "room_archive",
    RoomGarage = "room_garage",
    RoomMedical = "room_medical",
    RoomLibrary = "room_library",
    RoomWorkshop = "room_workshop",
}

export enum HazardousState {
    Suspected = "SUSPECTED",
    Confirmed = "CONFIRMED"
}

export enum WindowPaneType {
    OnePane = "one_pane",
    TwoPane = "two_pane",
    ThreePane = "three_pane",
}

export enum LevelType {
    Basement = "basement",
    GroundFloor = "ground_floor",
    NthFloor = "nth_floor",
    Attic = "attic"
}

export enum HeritageProtectionLevel {
    Byggnadsminne = "byggnadsminne",
    QMarkt = "q_markt",
    KMarkt = "k_markt",
    Riksintresse = "riksintresse",
    KulturhistorisktVardefull = "kulturhistoriskt_vardefull"
}